import * as React from "react";
const SvgFiRrIceSkate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ice-skate_svg__a)">
      <path
        fill="#062147"
        d="M23 19a1 1 0 0 0-1 1 2 2 0 0 1-2 2h-4v-4h2.1a3.905 3.905 0 0 0 3.9-3.9 6.014 6.014 0 0 0-4.823-5.883L13.3 7.44a2 2 0 0 1-1.592-1.7L11.3 2.576A3 3 0 0 0 7.619.086L2.91 1.42A4.015 4.015 0 0 0 0 5.269v8.73a4 4 0 0 0 4 4h1v4H1a1 1 0 0 0 0 2h19a4 4 0 0 0 4-4 1 1 0 0 0-1-1M2 14V5.268a2.01 2.01 0 0 1 1.455-1.925l4.652-1.32Q8.217 2 8.328 2a1 1 0 0 1 .986.848L9.466 4H7a1 1 0 1 0 0 2h2.729q.068.471.245.915L7.635 8.338a1 1 0 1 0 1.039 1.709l2.466-1.5q.398.328.866.544l-1.375 2.413a1 1 0 0 0 1.738.99l1.638-2.874 2.777.556A4.01 4.01 0 0 1 20 14.1a1.9 1.9 0 0 1-1.9 1.9H4a2 2 0 0 1-2-2m5 4h7v4H7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ice-skate_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrIceSkate;
